export var noop = function () { return ({}); };
export function id(v) {
    return v;
}
//# sourceMappingURL=misc.js.map